import React from "react";
import NavBar from "../../components/navbar-components/NavBar";
import Footer from "../../components/Footer";
import AdjustmentForm from "../../components/forms/Reports/Adjustment"
import Table from "../../components/Table";

const tableItems = [
    {"S.no": null,"Name": null, "Registration No": null, empty:true}
]

const Adjustment = () => {
    return (
        <>
        <NavBar/>
        <div className="bg-gray-200">
            <div className="mx-auto w-full bg-gray-200 py-5">
                    <AdjustmentForm/>
                <div className=" bg-white py-3 w-11/12 mx-auto rounded-b-md md:rounded-md">
                    <Table tableItems={tableItems}/>
                </div>
            </div>
        </div>
        <Footer/>
        </> 
    )
}

export default Adjustment